import { Pipe, PipeTransform } from '@angular/core';

import { __assign, __asyncValues } from 'tslib';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';

/* truncate filters start */
@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  transform(value: string) {
    return value.split(' ').slice(0, 2).join(' ') + '...';
  }

}
/* truncate filters end */

/* INR filters start */

@Pipe({name: 'INR'})
export class INRPipe implements PipeTransform {
  transform(value: number) {
    if (! isNaN(value)) {
        var result = value.toString().split('.');
        var lastThree = result[0].substring(result[0].length - 3);
        var otherNumbers = result[0].substring(0, result[0].length - 3);
        if (otherNumbers != '')
            lastThree = ',' + lastThree;
        var output = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
        if (result.length > 1) {
            output += "." + result[1];
        }            
        return output;
    }
  }
}

/* INR filters end */

/* INR filters start */

@Pipe({name: 'unique'})
export class UniquePipe implements PipeTransform {
  transform(value: number) {
    return function (collection, field) {
      const output = [];
      const keys = [];
      const fields = field && field.split('.');
      collection.forEach(function (item) {
        const key = fields ? fields.reduce((key, field) => key[field], item) : item;
        if (!keys.some(prev => (prev.equals(key)))) {
          keys.push(key);
          output.push(item);
        }
      });
      return output;
    };
  }
}

/* INR filters end */

	/* Capitalize Filter */

  @Pipe({name: 'capitalize'})
  export class capitalizePipe implements PipeTransform {
  transform(value: string) {
    return (!!value) ? value.charAt(0).toUpperCase() + value.substr(1).toLowerCase() : '';
  }
}

/* End of capitalize filter */

/* Product Full Name Filter */
  @Pipe({name: 'productFilter'})
  export class productFilterPipe implements PipeTransform {
  transform(value: string) {
    return function(input) {
      switch(input){
        case 'CI':
          return "Critical Illness";
        break;
        case 'CS':
          return "Cancer Secure";
        break;
        case 'PA':
          return "Personal Accident";
        break;
        case 'PLATINUM - ESSENTIAL':
          return "Platinum - Essential";
        break;
        case 'PLATINUM - ENHANCED':
          return "Platinum - Enhanced";
        break;
        case 'DIAMOND':
          return "Diamond";
        break;
        case 'ST':
          return "Super Top-up";
        break;
        default:
        break;
      }
     }
  }
}
/* End of product full name filter */

/* Trust As HTML Filter */

@Pipe({name: 'trustAsHTML'})
export class trustAsHTMLPipe implements PipeTransform {
transform(value: string) {
  return (!!value) ? value.charAt(0).toUpperCase() + value.substr(1).toLowerCase() : '';
}
}

@Pipe({
  name: 'safe'
})
export class SafePipe implements PipeTransform {

  constructor(protected sanitizer: DomSanitizer) {}
 
 public transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
            case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
            case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default: throw new Error(`Invalid safe type specified: ${type}`);
        }
  }
}

// app.filter('trustAsHTML', ['$sce', function($sce) {
//   return function(val) {
//       return $sce.trustAsHtml(val);
//   };
// }]);
/* End of trust as html filters */